import React, { Component } from 'react'
import { Row, Col } from 'common-controls/Core/index'
import styles from './UnknownRoute.less'

export class UnknownRoute extends Component {
  render () {
    const { location, uri } = this.props
    return (
      <div className='v100h v100w'>
        <Row noGutters>
          <Col md='6' className={styles.leftSide}>
            <div className={styles.logo}>
              <img src='/content/images/LogoText.png' />
            </div>
            <div className={styles.error}>
              <h2>Hmm... well that {`didn't`} work</h2>
              <p>It seems the location you are looking for is not available</p>
              <h4><b>Path: </b>{location.pathname}</h4>
              <h4><b>Match: </b>{uri}</h4>
            </div>
          </Col>
          <Col md='6' className={`d-none d-md-block ${styles.rightSide}`}>
            <div className={`text-white ${styles.overlay}`}>
            </div>
          </Col>
        </Row>
      </div >
    )
  }
}

export default UnknownRoute
